/**
 * Spankers India Theme Main JavaScript
 * High performance, zero dependency vanilla JS
 */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initNavigationDrawer();
  initSearchModal();
  initTabbedCollections();
  initProductSliders();
  initQuickSizeAdd();
  initProductPDP();
  initSizeChartModal();
});

/* ----------------------------------------------------
 * 1. CART DRAWER & AJAX CART
 * ---------------------------------------------------- */
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const trigger = document.getElementById('HeaderCartTrigger');
  const closeBtn = document.getElementById('CartDrawerClose');
  const backdrop = document.getElementById('CartDrawerBackdrop');

  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;

  // Intercept Drawer actions (qty increase/decrease/remove)
  drawer.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-action]');
    if (!btn) return;

    const action = btn.dataset.action;
    const key = btn.dataset.key;
    if (!key) return;

    const row = btn.closest('.cart-drawer-item');
    const qtyValEl = row.querySelector('.qty-val');
    let currentQty = parseInt(qtyValEl.textContent || '1');

    if (action === 'increase') currentQty += 1;
    if (action === 'decrease') currentQty -= 1;
    if (action === 'remove') currentQty = 0;

    await updateCartItem(key, currentQty);
  });
}

async function updateCartItem(key, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    const cart = await res.json();
    renderCartState(cart);
  } catch (err) {
    console.error('Failed to update cart:', err);
  }
}

async function addToCartAjax(variantId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });
    const item = await res.json();
    
    // Fetch full updated cart
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    renderCartState(cart);
    window.openCartDrawer();
  } catch (err) {
    console.error('Failed to add to cart:', err);
  }
}

function renderCartState(cart) {
  // Update header badge
  const badge = document.getElementById('CartCountBadge');
  if (badge) badge.textContent = cart.item_count;

  // Update drawer count bubble
  const countBubble = document.querySelector('.cart-drawer__count-bubble');
  if (countBubble) countBubble.textContent = '(' + cart.item_count + ')';

  // Free shipping recalculation
  const threshold = (window.SpankersTheme?.freeShippingThreshold || 999) * 100;
  const freeShippingEl = document.getElementById('CartFreeShipping');
  if (freeShippingEl) {
    if (cart.total_price >= threshold) {
      freeShippingEl.innerHTML = `
        <div class="cart-free-shipping__msg cart-free-shipping__msg--success">
          🎉 You have unlocked <strong>FREE SHIPPING</strong>!
        </div>
        <div class="cart-free-shipping__bar">
          <div class="cart-free-shipping__fill" style="width: 100%;"></div>
        </div>
      `;
    } else {
      const remaining = Math.round((threshold - cart.total_price) / 100);
      const percentage = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      freeShippingEl.innerHTML = `
        <div class="cart-free-shipping__msg">
          Add <strong>₹${remaining}</strong> more to unlock <strong>FREE SHIPPING</strong>
        </div>
        <div class="cart-free-shipping__bar">
          <div class="cart-free-shipping__fill" style="width: ${percentage}%;"></div>
        </div>
      `;
    }
  }

  // Update items body
  const body = document.getElementById('CartDrawerBody');
  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-drawer__empty">
        <div class="empty-icon">🛍️</div>
        <p class="empty-text">Your cart is currently empty.</p>
        <a href="/collections/all" class="btn btn--primary" id="EmptyCartShopBtn">EXPLORE LATEST DROPS</a>
      </div>
    `;
    const footer = document.getElementById('CartDrawerFooter');
    if (footer) footer.style.display = 'none';
  } else {
    let itemsHtml = '<div class="cart-drawer__items">';
    cart.items.forEach(item => {
      itemsHtml += `
        <div class="cart-drawer-item" data-line-item-key="${item.key}">
          <div class="cart-drawer-item__image">
            <img src="${item.image}" alt="${item.title}" width="75" height="100">
          </div>
          <div class="cart-drawer-item__details">
            <h4 class="cart-drawer-item__title"><a href="${item.url}">${item.product_title}</a></h4>
            <span class="cart-drawer-item__variant">${item.variant_title || ''}</span>
            <div class="cart-drawer-item__price">₹ ${Math.round(item.final_price / 100)}</div>
            <div class="cart-drawer-item__quantity">
              <button type="button" class="qty-btn" data-action="decrease" data-key="${item.key}">-</button>
              <span class="qty-val">${item.quantity}</span>
              <button type="button" class="qty-btn" data-action="increase" data-key="${item.key}">+</button>
              <button type="button" class="remove-btn" data-action="remove" data-key="${item.key}">Remove</button>
            </div>
          </div>
        </div>
      `;
    });
    itemsHtml += '</div>';
    body.innerHTML = itemsHtml;

    // Update footer
    let footer = document.getElementById('CartDrawerFooter');
    if (footer) {
      footer.style.display = 'block';
      const subtotalEl = footer.querySelector('.cart-drawer__subtotal-val');
      if (subtotalEl) subtotalEl.textContent = '₹ ' + Math.round(cart.total_price / 100);
    }
  }
}

/* ----------------------------------------------------
 * 2. QUICK SIZE PILLS ON PRODUCT CARDS
 * ---------------------------------------------------- */
function initQuickSizeAdd() {
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.size-pill-btn');
    if (!pill || pill.disabled) return;

    const variantId = pill.dataset.variantId;
    if (variantId) {
      pill.textContent = '...';
      addToCartAjax(variantId, 1).then(() => {
        pill.textContent = '✓';
        setTimeout(() => {
          pill.textContent = pill.getAttribute('title')?.split(' ')[1] || 'S';
        }, 1500);
      });
    }
  });
}

/* ----------------------------------------------------
 * 3. NAVIGATION DRAWER (Mobile)
 * ---------------------------------------------------- */
function initNavigationDrawer() {
  const drawer = document.getElementById('NavigationDrawer');
  const toggle = document.getElementById('HeaderMenuToggle');
  const closeBtn = document.getElementById('NavDrawerClose');
  const backdrop = document.getElementById('NavDrawerBackdrop');

  if (!drawer) return;

  function openMenu() {
    drawer.classList.add('navigation-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('navigation-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);
}

/* ----------------------------------------------------
 * 4. SEARCH MODAL
 * ---------------------------------------------------- */
function initSearchModal() {
  const modal = document.getElementById('SearchModal');
  const toggle = document.getElementById('HeaderSearchToggle');
  const closeBtn = document.getElementById('SearchClose');
  const backdrop = document.getElementById('SearchBackdrop');
  const input = document.getElementById('SearchInput');

  if (!modal) return;

  function openSearch() {
    modal.classList.add('search-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    if (input) setTimeout(() => input.focus(), 100);
  }

  function closeSearch() {
    modal.classList.remove('search-modal--open');
    modal.setAttribute('aria-hidden', 'true');
  }

  if (toggle) toggle.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);
}

/* ----------------------------------------------------
 * 5. TABBED COLLECTIONS
 * ---------------------------------------------------- */
function initTabbedCollections() {
  const tabBtns = document.querySelectorAll('.tab-btn');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.tabTarget;
      const parentSection = btn.closest('.tabbed-collections-section');
      if (!parentSection) return;

      parentSection.querySelectorAll('.tab-btn').forEach(b => {
        b.classList.remove('tab-btn--active');
        b.setAttribute('aria-selected', 'false');
      });

      parentSection.querySelectorAll('.tab-panel').forEach(p => {
        p.classList.remove('tab-panel--active');
      });

      btn.classList.add('tab-btn--active');
      btn.setAttribute('aria-selected', 'true');

      const targetPanel = document.getElementById(targetId);
      if (targetPanel) targetPanel.classList.add('tab-panel--active');
    });
  });
}

/* ----------------------------------------------------
 * 6. PRODUCT SLIDERS (Touch & Arrow Controls)
 * ---------------------------------------------------- */
function initProductSliders() {
  document.querySelectorAll('.products-slider-section').forEach(section => {
    const track = section.querySelector('.products-slider-track-wrap');
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');

    if (!track) return;

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -320, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: 320, behavior: 'smooth' });
      });
    }
  });
}

/* ----------------------------------------------------
 * 7. PRODUCT DETAIL PAGE (PDP)
 * ---------------------------------------------------- */
function initProductPDP() {
  const form = document.getElementById('ProductBuyForm');
  if (!form) return;

  // Variant size selection
  const sizeRadios = form.querySelectorAll('.size-radio-input');
  const variantHidden = document.getElementById('SelectedVariantId');
  sizeRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (variantHidden) variantHidden.value = radio.value;
    });
  });

  // Quantity +/-
  const qtyInput = document.getElementById('ProductQuantity');
  const decBtn = document.getElementById('QtyDecrease');
  const incBtn = document.getElementById('QtyIncrease');

  if (decBtn && qtyInput) {
    decBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (incBtn && qtyInput) {
    incBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // Intercept Add to Cart
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const variantId = variantHidden ? variantHidden.value : null;
    const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    if (variantId) {
      addToCartAjax(variantId, qty);
    }
  });

  // 1-Click Buy Now
  const buyNowBtn = document.getElementById('InstantBuyBtn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', async () => {
      const variantId = variantHidden ? variantHidden.value : null;
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (variantId) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        window.location.href = '/checkout';
      }
    });
  }

  // Gallery Thumbnails
  const mainImg = document.getElementById('ProductFeaturedImage');
  document.querySelectorAll('.gallery-thumb-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumb-btn').forEach(b => b.classList.remove('gallery-thumb-btn--active'));
      btn.classList.add('gallery-thumb-btn--active');
      const fullSrc = btn.dataset.fullSrc;
      if (mainImg && fullSrc) mainImg.src = fullSrc;
    });
  });
}

/* ----------------------------------------------------
 * 8. SIZE CHART MODAL
 * ---------------------------------------------------- */
function initSizeChartModal() {
  const modal = document.getElementById('SizeChartModal');
  const trigger = document.getElementById('SizeGuideTrigger');
  if (!modal) return;

  function openModal() {
    modal.classList.add('size-chart-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('size-chart-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', openModal);
  modal.querySelectorAll('[data-close-modal]').forEach(el => {
    el.addEventListener('click', closeModal);
  });
}
